export default "__VITE_ASSET__b4f61a4f__"